import CtrlTratativasPage from '@/modules/workflow/ctrl-tratativas/pages/CtrlTratativasPage.vue'

const routes = [
  {
    path: 'ctrl-tratativas',
    name: 'ctrl-tratativas',
    component: CtrlTratativasPage
  }
]

export default routes
